angular.module('rjmNg.api').factory("Trend", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->

    metalistParams =
      method: 'GET'
      cache: true
      isArray: true

    actions =
      getMetalist: metalistParams

    Trend = $resource(phpServiceUrl("/client/:clientId/trend/metalist"), {}, actions)
  ]
)
